import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const SubMenu = ({ item }) => {
    const [subnav, setSubnav] = useState(false);
    const showSubnav = () => setSubnav(!subnav);
    return (
        <>
            <NavLink
                to={!item.subNav ? item.path : false}
                onClick={item.subNav && showSubnav}
                className="h-12 mt-3"
                activeClassName ="bg-white rounded-lg italic text-gray-500 "
            >
            <div className="flex flex-row items-center h-12 transform hover:translate-x-2 transition-transform ease-in duration-200 hover:text-black rounded-lg">
                <span className="inline-flex items-center justify-center h-12 w-12 text-lg font-poppins">
                    {item.icon}
                </span>
                <span className="text-sm font-medium font-bold">{item.title}</span>
                <div className="ml-auto mr-4">
                     {item.subNav && subnav
                                ? item.iconOpened
                                : item.subNav
                                    ? item.iconClosed
                                    : null}
                </div>
            </div>
            </NavLink>
            {subnav &&
                item.subNav.map((item, index) => {
                    return (
                        <NavLink
                            to={item.path}
                            key={index}
                            // activeClassName="bg-green-600 rounded-lg ml-4"
                        >
                            <div >
                                <div className="hover:bg-blue-400 rounded-lg">
                                    <div className="flex flex-row items-center h-12 transform hover:translate-x-2 transition-transform ease-in duration-200 text-white pl-2">
                                          <span className="inline-flex items-center justify-center h-12 w-12 text-lg text-white">
                                            {item.icon}
                                          </span>
                                        <span className="text-sm font-medium font-poppins pr-2">
                                            {item.title}
                                          </span>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    );
                })}
        </>
    );
};

export default SubMenu;
